import { create } from "zustand";

export type User = {
  id: string;
  email: string;
  name: string;
  emailVerified: boolean;
};

export type Organization = {
  id: string;
  name: string;
  slug: string;
  plan: string;
  role: string;
};

interface AuthState {
  user: User | null;
  isAdmin: boolean;
  organizations: Organization[];
  currentOrganization: Organization | null;
  isLoading: boolean;
  setUser: (user: User | null) => void;
  setIsAdmin: (isAdmin: boolean) => void;
  setOrganizations: (orgs: Organization[]) => void;
  setCurrentOrganization: (org: Organization | null) => void;
  setLoading: (loading: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAdmin: false,
  organizations: [],
  currentOrganization: null,
  isLoading: true,
  setUser: (user) => set({ user }),
  setIsAdmin: (isAdmin) => set({ isAdmin }),
  setOrganizations: (organizations) =>
    set((state) => ({
      organizations,
      currentOrganization:
        state.currentOrganization ||
        organizations.find((o) => o.role === "owner") ||
        organizations[0] ||
        null,
    })),
  setCurrentOrganization: (currentOrganization) => set({ currentOrganization }),
  setLoading: (isLoading) => set({ isLoading }),
  logout: () =>
    set({
      user: null,
      isAdmin: false,
      organizations: [],
      currentOrganization: null,
    }),
}));
